module.exports = __webpack_public_path__ + "img/galery20.1e9dc8f9.jpg";